<app-command [command]="update$" (success)="saved()">
  <app-details-modal
    [title]="title"
    [saveLabel]="saveLabel"
    [form]="form"
    (cancel)="onCancel()"
    (save)="save()">
    <app-details-content>
      <ng-container *appLoad="let data of load$">
        <form [formGroup]="form">
          <div class="row">
            <div class="col">
              <lds-text-input
                formControlName="title"
                label="Title"
                placeholder="task title"
                [maxlength]="128"
                [isRequired]="data.schema.title | sharedRequirement"
                [validations]="{
                  required: 'Title is required',
                  maxLength: 'Title is too long'
                }">
              </lds-text-input>
            </div>
          </div>
          <div class="row">
            <div class="col">
              <lds-date-input
                formControlName="due"
                name="dueControl"
                label="Due date"
                [isRequired]="data.schema.due | sharedRequirement"
                [validations]="{
                  required: 'Due date is required',
                  date: 'Must be a valid date'
                }">
              </lds-date-input>
            </div>
            <div class="col">
              <lds-select
                formControlName="priority"
                label="Priority"
                [options]="data.schema.priority.options | ldsSelectOption"
                [config]="{ valueProperty: 'value', labelProperty: 'label' }"
                [showPlaceholder]="true"
                [isRequired]="data.schema.priority | sharedRequirement"
                [validations]="{
                  required: 'Please select a priority'
                }">
              </lds-select>
            </div>
          </div>
          <div class="row">
            <div class="col">
              <lds-text-area
                formControlName="notes"
                name="notes"
                label="Notes"
                placeholder="task details"
                [rows]="5"
                [maxlength]="2000"
                [showRemaining]="true"
                [expandable]="true">
              </lds-text-area>
            </div>
          </div>
          <div class="row mt-sm">
            <div class="col">
              <div class="tags-section">
                <label class="form-label">Tags</label>
                <lds-card>
                  <div class="tags-section__details">
                    <app-tag-input
                      [entityId]="isEditMode ? entityId : ''"
                      [entityType]="tagEntityType"
                      [taskId]="taskId"
                      [initialTags]="taskTags"
                      [showLabel]="false"
                      [readonly]="false"
                      (tagAdded)="onTagModified()"
                      (tagRemoved)="onTagModified()"
                      (tagsChanged)="onTagsChanged($event)">
                    </app-tag-input>
                  </div>
                </lds-card>
              </div>
            </div>
          </div>
        </form>
      </ng-container>
    </app-details-content>
  </app-details-modal>
</app-command>
